import React from 'react';
import TextSvg from '../Images/becomeOurPrestigeCustomer.svg';
import ArrowSvg from '../Images/Arrowblack.svg';
import './RoundText2.scss';

const RoundText2 = (props) => {
  const handleArrowClick = () => {
    const contactPopup = document.querySelector('.contact-popup');
    if (contactPopup) {
      if (contactPopup.classList.contains('contact-popup-active')) {
        contactPopup.classList.remove('contact-popup-active');
      }
      else {
        contactPopup.classList.add('contact-popup-active');
      }
    }
  };

  return (
    <div className='round-text2'>
      
        <img src={TextSvg} className='text-svg' style={{ height: `${props.height}` }} alt='become our prestige customer' />
        
      <img src={ArrowSvg} className='arrow-svg' style={{ width: `${props.arrwidth}` }} alt='arrow right' onClick={handleArrowClick} />
    </div>
  );
}

export default RoundText2;
